import type { GuestChatResponse, GuestContract, GuestSession } from "@/types";
import { apiClient } from "./client";

export const chatService = {
  /** Public: load a guest session (greeting + buttons + history) by token. */
  session: async (token: string, lang?: string): Promise<GuestSession> => {
    const { data } = await apiClient.get<GuestSession>(`/guest/${token}`, {
      params: lang ? { lang } : undefined,
    });
    return data;
  },

  /** Public: send a guest message (optionally pinned to a guide) and get the reply. */
  send: async (
    token: string,
    message: string,
    opts?: { lang?: string; guideId?: string }
  ): Promise<GuestChatResponse> => {
    const { data } = await apiClient.post<GuestChatResponse>(`/guest/${token}/chat`, {
      message,
      lang: opts?.lang,
      guide_id: opts?.guideId,
    });
    return data;
  },

  /** Public: resolve the contract to show for this guest (language fallback server-side). */
  contract: async (token: string, lang?: string): Promise<GuestContract> => {
    const { data } = await apiClient.get<GuestContract>(`/guest/${token}/contract`, {
      params: lang ? { lang } : undefined,
    });
    return data;
  },

  /**
   * Public: 체결본 교부 파일의 URL. 게스트 경로는 인증 헤더가 없어서
   * 평범한 `<a download>` 로 충분하다 — blob 다운로드 코드를 둘 이유가 없다.
   */
  contractDocumentUrl: (token: string): string =>
    `${apiClient.defaults.baseURL ?? ""}/guest/${token}/contract/document`,

  /** Public: accept the contract — the server snapshots what it resolves. */
  acceptContract: async (token: string, lang?: string): Promise<GuestContract> => {
    const { data } = await apiClient.post<GuestContract>(`/guest/${token}/contract/accept`, {
      lang,
    });
    return data;
  },
};
